import { ReactNode } from 'react';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="w-full max-w-none px-6 lg:px-8 xl:px-12 2xl:px-16 pt-12 pb-8">
        {children}
      </main>
    </div>
  );
}